import { render } from "./AppLayout.vue?vue&type=template&id=65619410&scoped=true&ts=true"
import script from "./AppLayout.vue?vue&type=script&lang=ts"
export * from "./AppLayout.vue?vue&type=script&lang=ts"

import "./AppLayout.vue?vue&type=style&index=0&id=65619410&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65619410"]])

export default __exports__